<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Open Balance Inventory
            <div class="settings-header__btn">
              <el-button
              type="success"
              size="mini"
              @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <div class="setting-component">
            <div class="wrap">
              <div class="wrap__tree">

                <div class="nav-tree" style="margin-bottom: 20px;">
                  <el-button
                  @click="openModalCreate"
                  class="nav-tree__item"
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-plus">Add Open Balance Inventory</el-button>
                </div>

                <div style="margin-bottom: 10px;">
                  <el-select
                    v-model="warehouse"
                    placeholder="Warehouse"
                    filterable
                    clearable
                    @change="changeWarehouse"
                    size="mini"
                    style="margin-right: 10px;">
                    <el-option v-for="item in warehouseList"
                      :key="item.id"
                      :label="item.warehouseName"
                      :value="item.id">
                    </el-option>
                  </el-select>

                  <el-date-picker
                    popper-class="custom-date-picker"
                    size="mini"
                    v-model="period"
                    @change="changePeriod"
                    style="margin-right: 10px;"
                    prefix-icon="el-icon-date"
                    type="daterange"
                    align="center"
                    format="d MMM yy"
                    value-format="timestamp"
                    range-separator=""
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </div>

                <el-table
                  max-height="600"
                  :data="data"
                  @cell-click="cellClick"
                  :empty-text="$t('general_noData')"
                  style="width: 100%">
                  <el-table-column
                    label="ID"
                    type="index"
                    align="center"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    label="Date"
                    width="200">
                    <template slot-scope="scope">
                      <div v-text="moment(scope.row.date).format('D MMM YYYY')"></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="warehouse"
                    label="Warehouse"
                    width="300">
                  </el-table-column>
                  <el-table-column
                    prop="currency"
                    label="Currency"
                    width="200">
                  </el-table-column>
                  <el-table-column
                    label="Total Amount"
                    width="200"
                    align="right">
                    <template slot-scope="scope">
                      <div v-text="formatPrice(scope.row.totalAmount)"></div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="Description"
                    align="center">
                    <template slot-scope="scope">
                      <el-popover
                        v-if="scope.row.description"
                        placement="top"
                        title="Description"
                        width="400"
                        trigger="click"
                        :content="scope.row.description">
                        <el-button size="mini" slot="reference" icon="el-icon-view"></el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="user"
                    label="User"
                    width="260">
                  </el-table-column>
                  <el-table-column
                    width="120"
                    align="center"
                    :label="$t('settings_accountThink_inventory_operations')">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="primary"
                        plain
                        icon="el-icon-edit"
                        @click="handleUpdate(scope.row)"></el-button>
                      <el-button
                        size="mini"
                        type="danger"
                        plain
                        icon="el-icon-delete"
                        @click="handleDelete(scope.row)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>

                <el-row type="flex" justify="center" style="margin-top: 20px;">
                  <el-col :span="12" style="text-align: center;">
                    <el-pagination
                      :current-page.sync="page"
                      @current-change="handleCurrentChange"
                      background
                      layout="prev, pager, next"
                      :page-size="15"
                      :total="total">
                    </el-pagination>
                  </el-col>
                </el-row>

              </div>
            </div>

            <create-update-modal @loadList="getData(1)" ref="createUpdateModal"></create-update-modal>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let moment = require('moment')
  import axios from 'axios'
  import CreateUpdateModal from '@/components/settings/accountTHINK/obi/CreateUpdateModal.vue'

  export default {
    name: "warehouse",
    components: {
      CreateUpdateModal,
    },
    data() {
      return {
        moment:moment,
        data: [],

        warehouseList: [],

        // filter
        warehouse: null,
        period: null,

        // pagination
        page: 1,
        total: 0,

        pickerOptions: {
          shortcuts: [{
            text: 'This month',
            onClick(picker) {
              const end = moment().endOf('month');
              const start = moment().startOf('month');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = moment().endOf('month').subtract(1, 'months');
              const start = moment().startOf('month').subtract(1, 'months');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = moment().endOf('month').subtract(1, 'months');
              const start = moment().startOf('month').subtract(3, 'months');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'This financial quarter',
            onClick(picker) {
              const end = moment().endOf('quarter');
              const start = moment().startOf('quarter');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last financial quarter',
            onClick(picker) {
              const end = moment().subtract(1, 'quarter').endOf('quarter');
              const start = moment().subtract(1, 'quarter').startOf('quarter');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'This financial year',
            onClick(picker) {
              const end = moment().endOf('year');
              const start = moment().startOf('year');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last financial year',
            onClick(picker) {
              const end = moment().endOf('year').subtract(1, 'year');
              const start = moment().startOf('year').subtract(1, 'year');
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    async mounted() {
      await this.getWarehouseList()
      await this.getDirectory()
      await this.getData()
    },
    methods: {
      async getWarehouseList() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.post(`api/v1/inventories/list?companyId=${this.$route.query.companyId}`)
          console.log("🚀 ~ file: CreateUpdateModal.vue:108 ~ directories ~ data:", data)
          this.warehouseList = data.inventoryList
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      async getDirectory() {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/journalEntry/directory?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.coaList = response.data.accountsList
            this.taxCodeList = response.data.taxList
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      async getData(page = this.page) {
        let loader = this.$loading.show()
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/items/openBalance/list?companyId=${this.$route.query.companyId}&warehouseId=${this.warehouse}&startDate=${this.period ? moment(this.period[0]).format('YYYY-MM-DD HH:mm:ss.sss') : 'null'}&endDate=${this.period ? moment(this.period[1]).format('YYYY-MM-DD HH:mm:ss.sss') : 'null'}&page=${page}`)
          this.data = data.list.rows
          this.total = data.list.count
        } catch (error) {
          console.log(error)
        } finally {
          loader.hide()
        }
      },
      handleCurrentChange(val) {
        this.getData(val)
      },
      openModalCreate(){
        this.$refs.createUpdateModal.openModal({ isCreate: true })
      },
      handleUpdate(row) {
        this.$refs.createUpdateModal.openModal({ isCreate: false, row })
      },
      async handleDelete(row) {
        this.$confirm('This will permanently delete. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(async () => {
          let loader = this.$loading.show();
          try {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            await axios.delete(`/api/v1/items/openBalance?id=${row.id}`)
            await this.getData()
            loader.hide()
            this.$message({ type: 'success', message: 'Delete completed' });
          } catch (error) {
            console.log('An error occurred:', error);
            loader.hide()
          }

        }).catch(() => {
          this.$message({ type: 'info', message: 'Delete canceled' });
        });
      },
      routerLink(page) {
        this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
      },
      changeWarehouse(value) {
        this.page = 1
        if (value === '') this.warehouse = null
        this.getData()
      },
      changePeriod(value) {
        this.page = 1
        if (value === null) this.period = null
        this.getData()
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      cellClick (row, column, cell, event) {
        if (column.label !== 'Action' && column.label !== 'Description') {
          this.$refs.createUpdateModal.openModal({ isCreate: false, row, onlyInfo: true })
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}
.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
